import { LogLevel } from '@azure/msal-common';
import { IEnvironment } from './ienvironment';

export const environment: IEnvironment = {
  production: false,
  logLevel: LogLevel.Warning,
  signUpSignInPolicyName: `b2c_1a_signup_signin_staging`,
  authorityDomain: 'testulplatform.b2clogin.com',
  authorityBase: 'https://testulplatform.b2clogin.com/testulplatform.onmicrosoft.com',
  defaultClientId: '84e7feb3-9872-4082-9418-22ef7b10bb06',
  scope: 'openid profile https://testulplatform.onmicrosoft.com/platform-systemtests-api-qa/read offline_access',
  loginRedirectUri: '/auth',
  logoutRedirectUri: '/',
  tenantId: '4eec6d53-627b-4ec6-9db5-74e6ef0ab27d'
};